import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top of the page when the route changes
    try {
      window.scrollTo(0, 0);
    } catch (e) {
      console.error(e);
    }
  }, [pathname]);

  return null;
}
